











import { Component, Vue, Prop } from "vue-property-decorator";
import StepsList from "@share/common/StepsList.vue";
import LogoutBtn from "@service/components/settings/components/buttons/LogoutButton.vue";

@Component({
    name: "OnboardingHeader",
    components: { StepsList, LogoutBtn }
})
export default class OnboardingHeader extends Vue {
    @Prop({required: true}) steps: object[];
    @Prop({required: true}) step: string;
}
